import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';


interface PasswordField {
  type : string,
  hide : boolean
}

@Component({
  selector: 'app-change-psw',
  templateUrl: './change-psw.component.html',
  styleUrls: ['./change-psw.component.css']
})
export class ChangePswComponent implements OnInit {

  field1 : PasswordField = {
    type : 'password',
    hide : true
  };

  field2 : PasswordField = {
    type : 'password',
    hide : true
  };

  field3 : PasswordField = {
    type: 'password',
    hide : true
  }

  changePswForm : FormGroup;

  msgError: string = "";

  constructor(public translate: TranslateService, public router: Router, private logService : LoginService, private toast : ToastService) {
    this.translate.setDefaultLang(localStorage.getItem('language_dm7') || 'it');
    this.changePswForm = new FormGroup({
      oldPsw: new FormControl(""),
      //mail: new FormControl(localStorage.getItem('email_dm7')),
      new_ps: new FormControl(""),
      new_password_conf: new FormControl("")
    });
  }

  ngOnInit(){}

  async changePsw(){
    let body = {
      //email: this.changePswForm.controls.mail.value,
      new_password: this.changePswForm.controls.new_ps.value,
      new_password_conf: this.changePswForm.controls.new_password_conf.value,
      old_password: this.changePswForm.controls.oldPsw.value  
    };
    let userId : string = localStorage.getItem('userId_einvoice') || "";
    let response = await this.logService.first_access_password(userId, body);
    if(response.success){
      this.router.navigate(['/Login']);
    } else {
      //this.toast.openToast(response.msg, "error");
        this.msgError = response.msg;
    }
  }

  changeVisibility(fieldNum : number) {
    switch (fieldNum) {
      case 1 : {
        this.field1.hide= !this.field1.hide;
        if(this.field1.hide) {
          this.field1.type= "password";
        } else {
          this.field1.type = "string";
        }
        break;
      };
      case 2 : {
        this.field2.hide= !this.field2.hide;
        if(this.field2.hide) {
          this.field2.type= "password";
        } else {
          this.field2.type = "string";
        }
        break;
      };
      case 3 : {
        this.field3.hide= !this.field3.hide;
        if(this.field3.hide) {
          this.field3.type= "password";
        } else {
          this.field3.type = "string";
        }
        break;
      };
    }
  }
}
